import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import { ValidationError } from 'yup';

import { t } from '~/helpers';

export function validationErrors(error, form) {
  const erros = {};

  if (error instanceof ValidationError) {
    error.inner.forEach((e) => {
      erros[e.path] = e.message.replace(`${e.path}`, '');
    });

    form.current.setErrors(erros);
  } else if (isArray(error)) error.forEach((e) => toast.error(t(e)));
  else toast.error(t(error?.message || String(error)));
}

export async function validation(schema, data) {
  await schema.validate(data, { abortEarly: false });
}
